import MaterialTable from "components/Table/MaterialTable";
import React, { useState, useEffect } from "react";
import {
  getwtdOrgType,
  editwtdOrgType,
  deletewtdOrgType,
  addwtdOrgType
} from "contexts/API/WTD/common";
import { useSweetAlert } from "components/Alert/SweetAlert";
const OrgType = props => {
  const { sweetAlerts } = useSweetAlert();
  const [columns] = useState([
    {
      title: "wtdOrgTypeId",
      field: "wtdOrgTypeId",
      hidden: true
    },
    {
      title: "ประเภทหน่วยงาน",
      field: "detail",
      cellStyle: {
        minWidth: "800px"
      }
    }
  ]);

  const [data, setData] = useState([]);
  useEffect(() => {
    getwtdOrgType()
      .then(result => {
        setData(result.data.data);
      })
      .catch(err => {
        sweetAlerts.error("ไม่สามารถดึงข้อมูล", err.toString());
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const optionsTable = { pageSize: 10 };
  return (
    <MaterialTable
      title={"ประเภทหน่วยงานที่เพิกถอนสิทธิเลือกตั้ง"}
      options={optionsTable}
      columns={columns}
      data={data}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              addwtdOrgType(newData.detail)
                .then(result => {
                  newData.wtdOrgTypeId = result.data.data.wtdOrgTypeId
                  setData([...data, newData]);
                  sweetAlerts.success("เพิ่มข้อมูลเรียบร้อยแล้ว");
                  
                })
                .catch(err => {
                  sweetAlerts.error("ไม่สามารถเพิ่มข้อมูลได้", err.toString());
                });

              resolve();
            }, 1000);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              const dataUpdate = [...data];
              const index = oldData.tableData.id;
              dataUpdate[index] = newData;

              editwtdOrgType(oldData.wtdOrgTypeId, newData.detail)
                .then(result => {
                  sweetAlerts.success("แก้ไขข้อมูลเรียบร้อยแล้ว");
                  setData([...dataUpdate]);
                })
                .catch(err => {
                  const errorMsg = err.response?.data?.desc || err.message || "เกิดข้อผิดพลาด";
                  sweetAlerts.error("ไม่สามารถแก้ไข อปท.", errorMsg);
                });
              resolve();
            }, 1000);
          }),
        onRowDelete: oldData =>
          new Promise((resolve, reject) => {
              const dataDelete = [...data];
              const index = oldData.tableData.id;
              dataDelete.splice(index, 1);

              deletewtdOrgType(oldData.wtdOrgTypeId)
                .then(result => {
                  sweetAlerts.success("ลบข้อมูลเรียบร้อยแล้ว");
                  setData([...dataDelete]);
                })
                .catch(err => {
                  sweetAlerts.error("ไม่สามารถลบข้อมูลได้", err.toString());
                });
              resolve();
          })
      }}
    />
  );
};
export default OrgType;
